import { AppBar, Box, BoxProps, IconButton, Typography } from "@mui/material"
import { signOut } from "aws-amplify/auth"
import Logo from "./images/logo_img01.png"
import { Link } from "react-router-dom"
import { Logout } from "@mui/icons-material"

export const Header = (props: BoxProps) => {
    const onLogoutButtonClick = () => {
        signOut().then().catch()
    }
    const fontFamily = [
        "メイリオ",
        "Meiryo",
        "ヒラギノ角ゴ Pro W3",
        "Hiragino Kaku Gothic Pro",
        "Osaka",
        "ＭＳ Ｐゴシック",
        "MS PGothic",
        "sans-serif"
    ]
    return (
        <Box {...props}>
            <AppBar component="header" position="relative" elevation={1} sx={{ borderWidth: 0, height: 64, backgroundColor: "transparent" }}>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Box display={"flex"}>
                        <Link to={"http://app.rs.miraiz-connect.jp/admin"} target="_blank">
                            <Box
                                component="img"
                                sx={{
                                    height: 64
                                }}
                                alt="Logo"
                                src={Logo}
                                position={"relative"}
                            /></Link>
                        <Box alignContent={"center"} paddingLeft={2}>
                            <Typography fontWeight={"bold"} fontSize={15} fontFamily={fontFamily} color="#006c60">
                                あいおいニッセイ同和損保様　管理画面
                            </Typography>
                        </Box>
                    </Box>
                    <Box alignContent={"center"} justifyContent={"end"}>
                        {<IconButton color="primary" sx={{ fontSize: 12, color: "#006c60" }} onClick={onLogoutButtonClick}><Logout />Logout</IconButton>}
                    </Box>
                </Box>
            </AppBar>
        </Box>
    )
}

